<template>
    <div class="authPage flex">
        <div class="column">
            <div class="authPage-content">
                <div class="pagePretitle text-blue text-bold">
                    Welcome <span v-if="status !== 'new-no-lead'">back</span> to truesecurity
                </div>
                <div class="pageTitle text-center">
                    Welcome 
                    <span v-if="status === 'complete'"><span v-if="status !== 'new-no-lead'">back</span>. What do you want to do?</span>
                    <span v-if="status !== 'complete'">. We don't see any systems saved. Let's get started?</span>
                </div>
                <!-- Go to my quote -->
                <a
                    href="/assessment/system" 
                    onclick="mixpanel.track('startedExisting')"
                    class="loginLandingButton" 
                    v-if="status === 'complete'"
                >
                    <img src="/img/icon-reply_arrow.png" srcset="/img/icon-reply_arrow@2x.png 2x" alt="Arrow">
                    Go to my quote
                </a>
                <!-- Design a new system -->
                <a 
                    href="/assessment/start-over"
                    onclick="mixpanel.track('startedOver')"
                    class="loginLandingButton">
                    <img src="/img/icon-add.png" srcset="/img/icon-add@2x.png 2x" alt="Add">
                    Design a new system
                </a>
            </div>
        </div>
        <div class="column">
            <div class="authBackground"></div>
        </div>
    </div>
</template>

<style>
.loginLandingButton {
    background: #FFFFFF;
    box-shadow: 0 2px 11px 0 rgba(0,0,0,0.25);
    margin-bottom: 1em;
    color: #000000;
    text-decoration: none;
    padding: 1em;
    display: flex;
    border-radius: 8px;
    align-items: center;
}

.loginLandingButton img {
    margin-right: 1.1875em;
}
</style>

<style scoped>
.pageTitle {
    margin-bottom: 2em;
}
</style>



<script>
export default {
    data: () => ({
        status: null
    }),

    beforeMount() {
        this.status = this.$route.query.status
    },
}
</script>
